import Vue from 'vue'
import Vuex from 'vuex'

import Admin from './modules/admin'
import Departments from './modules/departments'
import querys from './modules/querys'
import User from './modules/user'
import query from './modules/query'
import csvPlantas from './modules/csvPlantas'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin: Admin,
    plants: Departments,
    userService: User,
    querys:querys,
    query: query,
    csvplantas: csvPlantas
  }
})
